import { TextReview, VideoReview } from '../types';
// car
import { Andrew } from './car/Andrew';
import { AnneMarie } from './car/AnneMarie';
import { BonniePeterson } from './car/BonniePeterson';
import { Eryk } from './car/Eryk';
import { Ishan } from './car/Ishan';
import { Mary } from './car/Mary';
import { Nina } from './car/Nina';
import { RyanAllen } from './car/RyanAllen';
import { Samantha } from './car/Samantha';
import { Taylor } from './car/Taylor';
// home
import { Jan } from './home/Jan';
import { LuisHernandez } from './home/LuisHernandez';
import { MaryNock } from './home/MaryNock';
import { MichalDiaz } from './home/MichalDiaz';
import { RyanCuddy } from './home/RyanCuddy';
// life
import { KellyCogan } from './life/KellyCogan';
// pet
import { AlexFaust } from './pet/AlexFaust';
import { AllysonHurley } from './pet/AllysonHurley';
import { AmeliaPowell } from './pet/AmeliaPowell';
import { AnnePaas } from './pet/AnnePaas';
import { BobJacobsen } from './pet/BobJacobsen';
import { BreannaGloverVanRensselaer } from './pet/BreannaGloverVanRensselaer';
import { DanielGartshein } from './pet/DanielGartshein';
import { DawnRado } from './pet/DawnRado';
import { DeniseMcKay } from './pet/DeniseMcKay';
import { DennisWright } from './pet/DennisWright';
import { DianaShotko } from './pet/DianaShotko';
import { KristieRoth } from './pet/KristieRoth';
import { Lisa } from './pet/Lisa';
import { LisaNewell } from './pet/LisaNewell';
import { NatalieWoodrum } from './pet/NatalieWoodrum';
import { Marissa } from './pet/Marissa';
import { MarkLevine } from './pet/MarkLevine';
import { MrignayniChhotwani } from './pet/MrignayniChhotwani';
import { RachelHill } from './pet/RachelHill';
import { Sandra } from './pet/Sandra';
import { SophiaFranklin } from './pet/SophiaFranklin';
import { TarasMelnychenko } from './pet/TarasMelnychenko';
import { Wendy } from './pet/Wendy';
// renters
import { Annalise } from './renters/Annalise';
import { ChanelAllen } from './renters/ChanelAllen';
import { ChristopherMorford } from './renters/ChristopherMorford';
import { Isabella } from './renters/Isabella';
import { JacobShilue } from './renters/JacobShilue';
import { Jay } from './renters/Jay';
import { Jessica } from './renters/Jessica';
import { Leon } from './renters/Leon';
import { LeonelMiranda } from './renters/LeonelMiranda';
import { RachelGromack } from './renters/RachelGromack';
import { Sara } from './renters/Sara';
import { Sophia } from './renters/Sophia';
// texts
import { textReviews } from './text-reviews';

export const allProductReviews = [
  textReviews[1],
  LeonelMiranda, // renters
  Sandra,
  textReviews[0],
  Jay, // renters
  textReviews[2],
  MichalDiaz, // home
  ChanelAllen, // renters
  LuisHernandez, // home
  textReviews[3],
  Leon, // renters
  MaryNock, // home
  textReviews[8],
  Isabella, // renters
  textReviews[9],
  BreannaGloverVanRensselaer, // pet
  KristieRoth, // pet
  RyanAllen, // car
  textReviews[10],
  ChristopherMorford, // renters
  RyanCuddy, // home
  textReviews[4],
  AlexFaust, // pet
  BonniePeterson, // car
  DennisWright, // pet
  textReviews[32],
  Jan, // home
  textReviews[11],
  Jessica, // renters
  RachelGromack, // renters
  textReviews[53],
  Sophia, // renters
  MrignayniChhotwani, // pet
  textReviews[25],
  DianaShotko, // pet
  Sara, // renters
  Wendy, // pet
  textReviews[15],
  textReviews[16],
  Lisa, // pet
  MarkLevine, // renters
  textReviews[18],
  DawnRado, // pet
  textReviews[24],
  textReviews[17],
  Annalise, // renters
  textReviews[26],
  AnnePaas, // pet
];

export const carReviews: (VideoReview | TextReview)[] = [
  BonniePeterson,
  textReviews[1],
  textReviews[0],
  Ishan,
  textReviews[2],
  Mary,
  textReviews[3],
  RyanAllen,
  textReviews[4],
  Nina,
  textReviews[5],
  textReviews[6],
  textReviews[7],
  textReviews[48],
  Eryk,
  textReviews[49],
  Taylor,
  textReviews[50],
  Samantha,
  textReviews[51],
  Andrew,
  textReviews[52],
  textReviews[53],
  AnneMarie,
];

export const homeReviews: (VideoReview | TextReview)[] = [
  Jan,
  textReviews[30],
  LuisHernandez,
  textReviews[31],
  textReviews[33],
  MaryNock,
  textReviews[32],
  MichalDiaz,
  textReviews[34],
  textReviews[55],
  RyanCuddy,
  textReviews[56],
];

export const petReviews: (VideoReview | TextReview)[] = [
  AlexFaust,
  textReviews[15],
  AllysonHurley,
  AmeliaPowell,
  AnnePaas,
  BobJacobsen,
  BreannaGloverVanRensselaer,
  DanielGartshein,
  DawnRado,
  DeniseMcKay,
  DennisWright,
  DianaShotko,
  KristieRoth,
  Lisa,
  LisaNewell,
  NatalieWoodrum,
  Marissa,
  MarkLevine,
  MrignayniChhotwani,
  RachelHill,
  Sandra,
  SophiaFranklin,
  TarasMelnychenko,
  Wendy,
];

export const rentersReviews: (VideoReview | TextReview)[] = [
  Annalise,
  textReviews[35],
  ChanelAllen,
  ChristopherMorford,
  textReviews[26],
  Isabella,
  textReviews[29],
  JacobShilue,
  Jay,
  textReviews[25],
  Jessica,
  textReviews[28],
  Leon,
  LeonelMiranda,
  textReviews[27],
  RachelGromack,
  textReviews[24],
  Sara,
  Sophia,
  textReviews[36],
  textReviews[37],
  textReviews[38],
  textReviews[39],
  textReviews[40],
];

export const lifeReviews: (VideoReview | TextReview)[] = [
  KellyCogan,
  textReviews[8],
  textReviews[9],
  textReviews[10],
  textReviews[11],
  textReviews[12],
  textReviews[13],
  textReviews[14],
  textReviews[23],
  textReviews[41],
  textReviews[42],
  textReviews[43],
  textReviews[44],
  textReviews[45],
  textReviews[46],
  textReviews[47],
];
